import React, { useState } from "react";
import "./style.scss";
import { BsBellFill, BsSearch, BsCaretDownFill } from "react-icons/bs";
import { BiLogOutCircle, BiSolidLogOut, BiSolidUser } from "react-icons/bi";
import { Colors } from "../../../utilities/colors";
import useAppStore from "../../../store/AppStore";
import { useLogout } from "../../../utilities/logout";
import { Avatar, Divider, Popover } from "antd";
import { useNavigate } from "react-router";

const Header = () => {
  const navigate = useNavigate();
  const { authorizationData, userInfos } = useAppStore();
  const { doLogout } = useLogout();
  const [openUserMenu, setOpenUserMenu] = useState<boolean>(false);

  const onLogout = async () => {};
  return (
    <div className="d-flex justify-content-between">
      <div>{/* <BsSearch size={20} color={Colors.black} /> */}</div>
      <div className="d-flex align-items-center">
        <div className="h-i-btn">
          <BsBellFill size={18} color={Colors.black} />
        </div>
        <div className="h-i-btn">
          <Avatar
            shape="square"
            size="small"
            src={
              authorizationData?.user?.image?.contentUrl
                ? authorizationData.user.image.contentUrl
                : undefined
            }
            icon={
              !authorizationData?.user?.image?.contentUrl && (
                <BiSolidUser size={22} color={Colors.black} />
              )
            }
          />
        </div>
        <Popover
          placement="bottomRight"
          content={
            <div className="p-0 m-0">
              <ul className="list-unstyled p-0 m-0">
                <li className="p-2 text-success" onClick={() => {}}>
                  <Avatar
                    src={
                      authorizationData?.user?.image?.contentUrl
                        ? authorizationData.user.image.contentUrl
                        : undefined
                    }
                  />{" "}
                  {authorizationData?.user.email}
                </li>
                {/* <Divider /> */}
                <div
                  style={{
                    borderTop: "dashed 1px #D3D3D3",
                  }}
                >
                  {" "}
                </div>
                <li
                  className="p-2 cursor-pointer text-danger"
                  onClick={doLogout}
                >
                  <div className=" d-flex gap-2 w-100 align-items-center">
                    <BiLogOutCircle
                      style={{
                        fontSize: "25px",
                      }}
                    />
                    <div className="">
                      <span>Déconnexion</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          }
        >
          <div className="d-flex align-items-center cursor-pointer">
            <span>
              {userInfos?.fullname}
              {/* <BiLogOutCircle /> */}
            </span>
            <div className="p-1">
              <BsCaretDownFill size={12} color={Colors.black} />
            </div>
          </div>
        </Popover>
      </div>
    </div>
  );
};

export default Header;
